export default __webpack_public_path__ + "static/media/EducationalVideos.5c47adf4.png";